import { render, staticRenderFns } from "./ValidateComponent.vue?vue&type=template&id=e5c29eae"
import script from "./ValidateComponent.vue?vue&type=script&lang=js"
export * from "./ValidateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports